import React, { useState, useEffect } from "react";
import { Button, Drawer, Radio, Space } from "antd";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { AiOutlineHome } from "react-icons/ai";

const Navbar = ({
  headerCheckoutButtonText = "",
  headerCheckoutButtonTextOnClick = () => { },
  breadcrumbs = [],
  breadcrumbsVisible = true,
  headerDownloadButtonOnClick = () => { },
  switchOverWidth = 950
}) => {
  const [levelOfNav, setLevelOfNav] = useState("large");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= switchOverWidth) setLevelOfNav("large");
      else setLevelOfNav("small");
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= switchOverWidth) setLevelOfNav("large");
      else setLevelOfNav("small");
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [switchOverWidth]);

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        position: "fixed",
        top: "0",
        right: "0",
        left: "0",
        zIndex: "99",
      }}
      id="navbar"
    >
      <div
        style={{
          height: "4rem",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          display: "flex",
          maxWidth: "98vw",
          marginLeft: "auto",
          marginRight: "auto",

        }}
      >
        <a
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "1.5rem",
          }}
          href="https://wegethertravel.com"
          target="_blank"
        >
          {levelOfNav === "large" ? (
            <img
              src={"/Wegether_Logo.png"}
              style={{
                height: "1.8rem",
              }}
            />
          ) : (
            <img
              src={"/app_icon_transparent.png"}
              style={{
                height: "2.7rem",
                padding: "0.4rem",
              }}
            />
          )}
        </a>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          {levelOfNav === "large" ? (
            <>
              <a
                style={{
                  color: "grey",
                  fontSize: "1rem",
                  fontStyle: "normal",
                  padding: "0.5rem",
                  display: "inline-block",
                  textDecoration: "none",
                  fontWeight: "500",
                }}
                className="poppins-regular"
                href="https://wegethertravel.com/about"
                target="_blank"
              >
                About
              </a>
              <a
                style={{
                  color: "grey",
                  fontSize: "1rem",
                  fontStyle: "normal",
                  padding: "0.5rem",
                  display: "inline-block",
                  textDecoration: "none",
                  fontWeight: "500",
                }}
                className="poppins-regular"
                href="https://wegethertravel.com/features"
                target="_blank"
              >
                Features
              </a>
              <a
                style={{
                  color: "grey",
                  fontSize: "1rem",
                  fontStyle: "normal",
                  padding: "0.5rem",
                  display: "inline-block",
                  textDecoration: "none",
                  fontWeight: "500",
                }}
                className="poppins-regular"
                href="https://wegethertravel.com/blog"
                target="_blank"
              >
                Blog
              </a>
              <a
                style={{
                  color: "grey",
                  fontSize: "1rem",
                  fontStyle: "normal",
                  padding: "0.5rem",
                  display: "inline-block",
                  textDecoration: "none",
                  fontWeight: "500",
                }}
                className="poppins-regular"
                href="https://wegethertravel.com/contact-us"
                target="_blank"
              >
                Contact Us
              </a>
              <a
                href="https://wegethertravel.com/faq"
                style={{
                  color: "grey",
                  fontSize: "1rem",
                  fontStyle: "normal",
                  padding: "0.5rem",
                  display: "inline-block",
                  textDecoration: "none",
                  fontWeight: "500",
                }}
                className="poppins-regular"
                target="_blank"
              >
                FAQ
              </a>
              {headerCheckoutButtonText ? (
                <button
                  style={{
                    backgroundColor: "transparent",
                    border: "3px solid #fa5705",
                    padding: "0.4rem 1rem",
                    borderRadius: "1.4rem",
                    margin: "0.5rem",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#fa5705";
                    e.currentTarget.querySelector("span").style.color =
                      "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.querySelector("span").style.color =
                      "#fa5705";
                  }}
                  onClick={headerCheckoutButtonTextOnClick}
                >
                  <span
                    style={{
                      color: "#fa5705",
                      fontSize: "1rem",
                      fontStyle: "normal",
                    }}
                    className="poppins-regular"
                  >
                    {headerCheckoutButtonText}
                  </span>
                </button>
              ) : null}



              <button
                style={{
                  backgroundColor: "transparent",
                  border: "3px solid #fa5705",
                  padding: "0.4rem 1rem",
                  borderRadius: "1.4rem",
                  margin: "0.5rem",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#fa5705";
                  e.currentTarget.querySelector("span").style.color = "#ffffff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.querySelector("span").style.color = "#fa5705";
                }}
                onClick={headerDownloadButtonOnClick}
              >
                <span
                  style={{
                    color: "#fa5705",
                    fontSize: "1rem",
                    fontStyle: "normal",
                  }}
                  className="poppins-regular"
                >
                  Download Wegether
                </span>
              </button>

              <a
                style={{
                  backgroundColor: "transparent",
                  border: "3px solid #fa5705",
                  padding: "0.4rem 1rem",
                  borderRadius: "1.4rem",
                  margin: "0.5rem",
                  transition: "all 0.3s ease",
                  marginRight: "1.5rem",
                  textDecoration: "none",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#fa5705";
                  e.currentTarget.querySelector("span").style.color = "#ffffff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.querySelector("span").style.color = "#fa5705";
                }}
                // onClick={headerDownloadButtonOnClick}
                href="https://wegethertravel.com/download-wegether-guide"
                target="_blank"
              >
                <span
                  style={{
                    color: "#fa5705",
                    fontSize: "1rem",
                    fontStyle: "normal",
                  }}
                  className="poppins-regular"
                >
                  Become a Guide
                </span>
              </a>
            </>
          ) : (
            <>
              {headerCheckoutButtonText ? (
                <button
                  style={{
                    backgroundColor: "transparent",
                    border: "3px solid #fa5705",
                    padding: "0.4rem 1rem",
                    borderRadius: "1.4rem",
                    margin: "0.5rem",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#fa5705";
                    e.currentTarget.querySelector("span").style.color =
                      "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.querySelector("span").style.color =
                      "#fa5705";
                  }}
                  onClick={headerCheckoutButtonTextOnClick}
                >
                  <span
                    style={{
                      color: "#fa5705",
                      fontSize: "1rem",
                      fontStyle: "normal",
                    }}
                    className="poppins-regular"
                  >
                    {headerCheckoutButtonText}
                  </span>
                </button>
              ) : null}
              <SideDrawer
                headerCheckoutButtonText={headerCheckoutButtonText}
                headerCheckoutButtonTextOnClick={
                  headerCheckoutButtonTextOnClick
                }
                headerDownloadButtonOnClick={headerDownloadButtonOnClick}
              />
            </>
          )}
        </div>
      </div>
      {breadcrumbsVisible && (
        <div>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              position: "",
              bottom: "0",
              width: "100%",
              maxWidth: "100%",
              backgroundColor: "#f0f2f5",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "100%",
                maxWidth: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={index}>
                  <a
                    href={index < breadcrumbs.length - 1 ? crumb.path : undefined}
                    style={{
                      color: "gray",
                      textDecoration: "none",
                      width: "fit-content",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "500",
                      textAlign: "center",
                      height: "2.2rem",
                      maxWidth: `${100 / breadcrumbs.length}%`,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "1.2rem",
                    }}
                  >
                    <div
                      style={{
                        paddingRight: "0.2rem",
                        marginBottom: "-0.25rem",
                        height: "fit-content",
                        backgroundColor: "",
                      }}
                    >
                      {index == 0 && (
                        <AiOutlineHome
                          style={{ height: "1.2rem", width: "1.2rem" }}
                        />
                      )}
                    </div>
                    <div
                      style={{
                        height: "fit-content",
                        backgroundColor: "",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        marginTop: "-0.1rem",
                        cursor: index >= breadcrumbs.length - 1 ? "not-allowed" : undefined
                      }}
                    >
                      {crumb.label}
                    </div>
                  </a>
                  {index < breadcrumbs.length - 1 && (
                    <span
                      style={{
                        color: "gray",
                        paddingLeft: "0.5rem",
                        paddingRight: "0.5rem",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "-0.15rem",
                        fontSize: "1.2rem",
                      }}
                    >
                      {" "}
                      <AiOutlineDoubleRight />{" "}
                    </span>
                  )}
                </React.Fragment>
              ))}
              <div
                style={{
                  height: "0.5rem",
                  width: "0.5rem",
                }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const SideDrawer = ({
  headerCheckoutButtonText,
  headerCheckoutButtonTextOnClick,
  headerDownloadButtonOnClick,
}) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("left");
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Space>
        <button
          style={{
            backgroundColor: "transparent",
            border: "none",
            paddingLeft: "1rem",
            paddingRight: "1rem",
          }}
          onClick={showDrawer}
        >
          <AiOutlinePlus style={{ color: "#fa5705", height: 30, width: 30 }} />
        </button>
      </Space>
      <Drawer
        title=""
        placement={"left"}
        closable={true}
        onClose={onClose}
        open={open}
        key={placement}
      >
        <a
          style={{
            color: "grey",
            fontSize: "1rem",
            fontStyle: "normal",
            padding: "0.5rem",
            fontWeight: "500",
            display: "block"
          }}
          className="poppins-regular"
          href="https://wegethertravel.com/about"
          target="_blank"
        >
          About
        </a>
        <a
          style={{
            color: "grey",
            fontSize: "1rem",
            fontStyle: "normal",
            padding: "0.5rem",
            fontWeight: "500",
            display: "block"
          }}
          className="poppins-regular"
          href="https://wegethertravel.com/features"
          target="_blank"
        >
          Features
        </a>
        <a
          style={{
            color: "grey",
            fontSize: "1rem",
            fontStyle: "normal",
            padding: "0.5rem",
            fontWeight: "500",
            display: "block"
          }}
          className="poppins-regular"
          href="https://wegethertravel.com/blog"
          target="_blank"
        >
          Blog
        </a>
        <a
          style={{
            color: "grey",
            fontSize: "1rem",
            fontStyle: "normal",
            padding: "0.5rem",
            fontWeight: "500",
            display: "block"
          }}
          className="poppins-regular"
          href="https://wegethertravel.com/contact-us"
          target="_blank"
        >
          Contact Us
        </a>
        <a
          style={{
            color: "grey",
            fontSize: "1rem",
            fontStyle: "normal",
            padding: "0.5rem",
            fontWeight: "500",
          }}
          className="poppins-regular"
          href="https://wegethertravel.com/faq"
          target="_blank"
        >
          FAQ
        </a>
        {headerCheckoutButtonText ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              style={{
                backgroundColor: "transparent",
                border: "3px solid #fa5705",
                padding: "0.4rem 1rem",
                borderRadius: "1.4rem",
                margin: "0.5rem",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#fa5705";
                e.currentTarget.querySelector("span").style.color = "#ffffff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.querySelector("span").style.color = "#fa5705";
              }}
              onClick={headerCheckoutButtonTextOnClick}
            >
              <span
                style={{
                  color: "#fa5705",
                  fontSize: "1rem",
                  fontStyle: "normal",
                }}
                className="poppins-regular"
              >
                {headerCheckoutButtonText}
              </span>
            </button>
          </div>
        ) : null}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            style={{
              backgroundColor: "transparent",
              border: "3px solid #fa5705",
              padding: "0.4rem 1rem",
              borderRadius: "1.4rem",
              margin: "0.5rem",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#fa5705";
              e.currentTarget.querySelector("span").style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.querySelector("span").style.color = "#fa5705";
            }}
            onClick={headerDownloadButtonOnClick}
          >
            <span
              style={{
                color: "#fa5705",
                fontSize: "1rem",
                fontStyle: "normal",
              }}
              className="poppins-regular"
            >
              Download Wegether
            </span>
          </button>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <a
            style={{
              backgroundColor: "transparent",
              border: "3px solid #fa5705",
              padding: "0.4rem 1rem",
              borderRadius: "1.4rem",
              margin: "0.5rem",
              transition: "all 0.3s ease",
              textDecoration: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#fa5705";
              e.currentTarget.querySelector("span").style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.querySelector("span").style.color = "#fa5705";
            }}
            href="https://wegethertravel.com/download-wegether-guide"
            target="_blank"
          >
            <span
              style={{
                color: "#fa5705",
                fontSize: "1rem",
                fontStyle: "normal",
              }}
              className="poppins-regular"
            >
              Become a Guide
            </span>
          </a>
        </div>
      </Drawer>
    </>
  );
};

export default Navbar;
